document.addEventListener('DOMContentLoaded', function () {
  const wrapper = document.querySelector('.category-collections-wrapper');
  if (!wrapper) return;

  // Helper: Get all active product type filters from URL (array)
  function getActiveProductTypes() {
    const params = new URLSearchParams(window.location.search);
    // Shopify uses multiple filter.p.product_type params for multi-select
    return params.getAll('filter.p.product_type');
  }

  // Set active class on the correct filter link (only one)
  function setActiveLink() {
    const activeTypes = getActiveProductTypes().map(v => decodeURIComponent(v.replace(/\+/g, ' ')).toLowerCase());
    let anyActive = false;
    wrapper.querySelectorAll('a').forEach(a => a.classList.remove('active'));
    wrapper.querySelectorAll('.filter-link').forEach(a => {
      const filterValue = a.getAttribute('data-filter-value').toLowerCase();
      if (activeTypes.includes(filterValue)) {
        a.classList.add('active');
        anyActive = true;
      }
    });
    const allLink = wrapper.querySelector('.all-link');
    if (allLink) {
      if (!anyActive) {
        allLink.classList.add('active');
      } else {
        allLink.classList.remove('active');
      }
    }
  }

  // AJAX load products and update grid
  function loadProducts(url) {
    const gridContainer = document.getElementById('ProductGridContainer');
    if (!gridContainer) return;
    gridContainer.classList.add('loading');
    fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(res => res.text())
      .then(html => {
        const temp = document.createElement('div');
        temp.innerHTML = html;
        const newGrid = temp.querySelector('#ProductGridContainer');
        if (newGrid) {
          gridContainer.innerHTML = newGrid.innerHTML;
        }
        setActiveLink();
        gridContainer.classList.remove('loading');
      });
  }

  // When a horizontal filter link is clicked (single select)
  wrapper.addEventListener('click', function (e) {
    const a = e.target.closest('a.filter-link');
    if (!a) return;
    e.preventDefault();
    const url = new URL(a.href, window.location.origin);
    // Remove all other filter.p.product_type params, keep only the clicked one
    url.searchParams.delete('filter.p.product_type');
    url.searchParams.append('filter.p.product_type', a.getAttribute('data-filter-value'));
    window.history.pushState({}, '', url.toString());
    loadProducts(url.toString());
    setActiveLink();

    // Uncheck all checkboxes in facets, check only the one matching this filter
    document.querySelectorAll('.mobile-facets__checkbox').forEach(input => {
      input.checked = (input.value === a.getAttribute('data-filter-value'));
    });
  });

  // When "All" is clicked
  wrapper.addEventListener('click', function (e) {
    const a = e.target.closest('a.all-link');
    if (!a) return;
    e.preventDefault();
    const url = a.href;
    window.history.pushState({}, '', url);
    loadProducts(url);
    setActiveLink();
    // Uncheck all checkboxes in facets
    document.querySelectorAll('.mobile-facets__checkbox').forEach(input => {
      input.checked = false;
    });
  });

  // When a checkbox in the facets drawer is changed (multi-select)
  document.addEventListener('change', function (e) {
    if (!e.target.classList.contains('mobile-facets__checkbox')) return;
    // Build new URL with all checked values
    const params = new URLSearchParams(window.location.search);
    params.delete('filter.p.product_type');
    document.querySelectorAll('.mobile-facets__checkbox:checked').forEach(input => {
      params.append('filter.p.product_type', input.value);
    });
    const url = window.location.pathname + '?' + params.toString();
    window.history.pushState({}, '', url);
    loadProducts(url);
    setActiveLink();
  });

  // Handle back/forward navigation
  window.addEventListener('popstate', function () {
    setActiveLink();
    loadProducts(window.location.href);
  });

  // Initial set
  setActiveLink();
});